export default __webpack_public_path__ + "static/media/CarDetailingAllFinish.e52368ec.jpg";